<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="contact-information">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Mode d'envoi des liens de connexion au site de vote</p>
        <p class="no-margin dark-gray bold">Choisissez le mode d'envoi des identifiants de connexion</p>
      </div>
    </div>
  </div>

  <div id="sending-mode" class="p-20">
    <p class="dark-blue bold no-margin mb-10">Sélection du mode d'envoi <span class="red">*</span></p>
    <div class="mb-20">
      <label class="flex align-items-start gap-10 mb-10">
        <input type="radio" name="sendMode" [value]="false" [(ngModel)]="smsMode" (ngModelChange)="smsModeChange.emit($event)">
        <div class="flex flex-column">
          <span class="dark-blue">Email</span>
          <span class="dark-gray text-xs">Lien envoyé par e-mail</span>
        </div>

      </label>
      <label class="flex align-items-start gap-10">
        <input type="radio" name="sendMode" [value]="true" [(ngModel)]="smsMode" (ngModelChange)="smsModeChange.emit($event)">
        <div class="flex flex-column">
          <span class="dark-blue">Double envoi</span>
          <span class="dark-gray text-xs">Lien envoyé par e-mail et par SMS</span>
        </div>
      </label>
    </div>

    <div class="bg-pastel-blue radius-10" style="border: solid 1px #C3DAFD;">
      <p class="dark-blue p-20 no-margin"><span class="bold">Information :</span> Le mode d'envoi détermine comment les électeurs recevront leurs liens de
        connexion au site de vote. Plusieurs modes peuvent être combinés pour assurer une meilleure couverture.</p>
    </div>
  </div>
</div>